<template>
  <a-modal class="attachable-move-modal"
           v-bind:class="{loaded, visible}"
           :visible="visible"
           title="Document verplaatsen"
           :closable="false"
           width="60%"
           data-dusk="attachable-move-modal"
  >

    <p><b>Deze actie zal de volgende documenten verplaatsen:</b></p>
    <div class="responsive-height-wrapper">
      <AttachableTableComponent :attachables="attachables"></AttachableTableComponent>
    </div>

    <div style="margin-top: 15px;">
      <p><b>Selecteer een klant:</b></p>
      <CustomerTabbedSelectComponent
          v-if="hasCustomerId"
          :customer-id="customerId"
          :value="selectedCustomer"
          v-on:customer-selected="onCustomerSelected">
      </CustomerTabbedSelectComponent>
      <CustomerSearchByNameComponent
          v-if="!hasCustomerId"
          :clear-results-after-selection="false"
          :value="selectedCustomer"
          v-on:customer-selected="onCustomerSelected">
      </CustomerSearchByNameComponent>
      <div v-if="hasSelectedCustomer" style="margin-top: 15px;">
        <p><b>Selecteer een hoofdcategorie:</b></p>
        <CategorySelectMainCategoryComponent
            :key="selectedCustomer.id"
            :value="selectedCategory"
            v-on:category-selected="onCategorySelected">
        </CategorySelectMainCategoryComponent>

        <div v-if="hasSelectedCategory" style="margin-top: 15px;">
          <p><b>Selecteer een map:</b></p>
          <AttachableCategorySelectByCustomerAndCategoryComponent
              :key="selectedCustomer.id + '-' + selectedCategory"
              :customer="selectedCustomer" :category="selectedCategory"
              v-on:category-selected="onAttachableCategorySelected">
          </AttachableCategorySelectByCustomerAndCategoryComponent>
        </div>
      </div>
    </div>

    <template slot="footer">
      <a-button key="back" @click="closeModal" type="default" :disabled="loading">
        Sluiten
      </a-button>
      <a-button key="submit" @click="submit" type="primary" :disabled="!hasSelectedAttachableCategory"
                :loading="loading">
        Verplaatsen
      </a-button>
    </template>

  </a-modal>
</template>

<script>
import attachableApi from '~/api/attachable';
import AttachableMenuComponent from "./MenuComponent";
import BadgeComponent from '~/modules/customer/components/BadgeComponent';
import HumanFilesizeComponent from '~/components/HumanFilesizeComponent';
import AttachableShowComponent from "./ShowComponent";
import CustomerSearchByNameComponent from "../../customer/components/SearchByNameComponent";
import CustomerTabbedSelectComponent from "../../customer/components/TabbedSelectComponent";
import CategorySelectMainCategoryComponent from "../../category/components/SelectMainCategoryComponent";
import AttachableCategorySelectByCustomerAndCategoryComponent
  from "../../attachable_category/components/SelectByCustomerAndCategoryComponent";
import AttachableTableComponent from "./TableComponent";

const moment = require('moment');

export default {
  name: "AttachableMoveModalComponent",
  props: {
    attachables: {
      type: Array,
      required: true
    },
    customerId: {
      type: [String, Number],
      required: false,
      default: null
    },
    category: {
      type: [String, Number],
      required: false,
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    AttachableTableComponent,
    AttachableCategorySelectByCustomerAndCategoryComponent,
    CategorySelectMainCategoryComponent,
    CustomerSearchByNameComponent,
    CustomerTabbedSelectComponent,
    AttachableShowComponent,
    AttachableMenuComponent,
    BadgeComponent,
    HumanFilesizeComponent
  },
  data() {
    return {
      loaded: false,
      loading: false,
      selectedCustomer: null,
      selectedCategory: null,
      selectedAttachableCategory: null,
    }
  },
  computed: {
    hasCustomerId() {
      return this.customerId !== null;
    },
    customer() {
      return this.$store.getters.getCustomerById(this.customerId);
    },
    hasSelectedCustomer() {
      return typeof this.selectedCustomer !== "undefined" && this.selectedCustomer !== null;
    },
    hasSelectedCategory() {
      return typeof this.selectedCategory !== "undefined" && this.selectedCategory !== null;
    },
    hasSelectedAttachableCategory() {
      return this.selectedAttachableCategory !== null;
    },
    attachableIds() {
      return this.attachables.map(attachable => {
        return attachable.id;
      });
    },
  },
  async created() {
    if (this.hasCustomerId) {
      await this.$store.dispatch('fetchCustomer', this.customerId);
      this.selectedCustomer = this.customer;
    }

    if (this.category !== null) {
      this.selectedCategory = this.category;
    }

    this.loaded = true;
  },
  methods: {
    onCustomerSelected(customer) {
      this.selectedCustomer = customer;
      this.selectedCategory = null;
      this.selectedAttachableCategory = null;
    },
    onCategorySelected(category) {
      this.selectedCategory = category;
      this.selectedAttachableCategory = null;
    },
    onAttachableCategorySelected(attachableCategory) {
      this.selectedAttachableCategory = attachableCategory;
    },
    closeModal() {
      this.selectedCustomer = null;
      this.selectedCategory = null;
      this.selectedAttachableCategory = null;
      this.$emit('close');
    },
    submit() {
      this.loading = true;

      attachableApi.moveAll(this.attachableIds, this.selectedAttachableCategory.id).then(response => {
        this.closeModal();
        this.$emit('complete', response.data);
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>
tr td.half-padding {
  padding: 4px;
}

tr.selected {
  background-color: #1890ff1c;
}

table th.compact, table td.compact {
  white-space: nowrap;
  width: 1px !important;
}

tr .pencil-icon {
  display: none;
}

tr:hover .pencil-icon {
  display: initial;
}

.responsive-height-wrapper {
  max-height: 400px;
  overflow: auto;
}
</style>
